import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class BillingService {
  static getHeaders() {
    const token = JSON.parse(localStorage.getItem('accessToken'));
    return { Authorization: `Bearer ${token}` };
  }

  static async getHistory() {
    try {
      const res = await axios.get(`${adminUrl}/billing/history`, { headers: this.getHeaders() });
      return { status: 'ok', data: res.data.data };
    } catch { return { status: 'error' }; }
  }

  static async createIndividual(data) {
    try {
      const res = await axios.post(`${adminUrl}/billing/individual`, data, { headers: this.getHeaders() });
      return { status: 'ok', data: res.data.data };
    } catch { return { status: 'error' }; }
  }

  static async createBulk(data) {
    try {
      const res = await axios.post(`${adminUrl}/billing/create`, { data }, { headers: this.getHeaders() });
      return { status: 'ok', data: res.data.data };
    } catch { return { status: 'error' }; }
  }

  static async update(id, data) {
    try {
      const res = await axios.put(`${adminUrl}/billing/${id}`, data, { headers: this.getHeaders() });
      return { status: 'ok', data: res.data.data };
    } catch { return { status: 'error' }; }
  }

  static async remove(id) {
    try {
      await axios.delete(`${adminUrl}/billing/${id}`, { headers: this.getHeaders() });
      return { status: 'ok' };
    } catch { return { status: 'error' }; }
  }
}
